import {
  combine,
  withContext,
  withMemo,
  withCallback,
} from 'react-hooks-combine'
import { ServicesContext } from 'services/context'

import TriggersOverviewComponent from './component'
import { createColumns } from './columns.description'

export const TriggersOverview = combine(
  withContext(
    'adminTriggerService',
    ServicesContext,
    ({ adminTriggerService }) => adminTriggerService
  ),
  withMemo('columns', () => createColumns(), []),
  withCallback(
    'loadTriggers',
    ({ adminTriggerService }) =>
      (tableState) => {
        return adminTriggerService.query({
          page: tableState.page,
          size: tableState.pageSize,
        })
      },
    []
  )
)(TriggersOverviewComponent)
